"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,7.39V5.67a2.86,2.86,0,0,0-2.86-2.86H2.86A2.86,2.86,0,0,0,0,5.67V7.39H24ZM4,6.24a.57.57,0,1,1,.57-.57A.57.57,0,0,1,4,6.24Zm2.29,0a.57.57,0,1,1,.57-.57A.57.57,0,0,1,6.29,6.24Zm2.29,0a.57.57,0,1,1,.57-.57A.57.57,0,0,1,8.57,6.24Z",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,18.24V8.53H0v9.71A2.86,2.86,0,0,0,2.86,21.1H21.14A2.86,2.86,0,0,0,24,18.24Z",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "9.44",
    y: "17.06",
    width: "5.12",
    height: "0.63",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15,16.55h.6a1.36,1.36,0,0,1,.33-.2.25.25,0,0,1,0-.06V14.18a.26.26,0,1,1,.53,0v2.06h0a1.31,1.31,0,0,1,.85.32h.1a1.31,1.31,0,0,1,1.94.26H20.7a.26.26,0,1,0,0-.53H19.38V11.54a.26.26,0,0,0-.26-.26H4.88a.26.26,0,0,0-.26.26v4.75H3.3a.26.26,0,0,0,0,.53H4.43a1.31,1.31,0,0,1,1.94-.26h.1a1.31,1.31,0,0,1,.85-.32l.2,0V14.18a.26.26,0,1,1,.53,0v2.28l.12.09H15Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "5.52",
    cy: "17.55",
    r: "0.79",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "7.32",
    cy: "17.55",
    r: "0.79",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "16.49",
    cy: "17.55",
    r: "0.79",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "18.29",
    cy: "17.55",
    r: "0.79",
    fill: "#fff"
  }));
};

exports["default"] = _default;